import React from 'react';
import { TitleHeader } from 'web-library';
import RegisterResitRoute from '../../modules/resit/components/@candidate/RegisterResitRoute';

interface ResitFlowProps {
  title: string;
}

const ResitFlow = ({ title = '' }: ResitFlowProps) => (
  <>
    <TitleHeader title={title} />

    <RegisterResitRoute />
  </>
);

export default ResitFlow;
